import {useQueryParam, withUnstablePredictionsQueryParam} from '~utils/routeUtil';

/**
 * Whether the image browser was opened as the enhanced-testing "unstable predictions" gallery
 * (via the "View images" link on the test results).
 *
 * Note: useQueryParam parses with parseBooleans, so the `withUnstablePredictions=true` query param
 * arrives as the boolean `true`, not the string `'true'`.
 */
export function useIsUnstableGallery(): boolean {
  const [withUnstablePredictions] = useQueryParam(withUnstablePredictionsQueryParam);
  return withUnstablePredictions === true;
}
